/**
 * Run a Zod schema against form values and flatten the result into a
 * field -> message error map suitable for component state.
 * @param {object} schema a Zod schema
 * @param {object} values current form values
 * @return {{ valid: boolean, errors: object }} errors maps each invalid
 *         field name to its first issue's message; empty when valid
 */
export const validate = (schema, values) => {
    const result = schema.safeParse(values);

    if (result.success) {
        return { valid: true, errors: {} };
    }

    const errors = {};

    result.error.issues.forEach((issue) => {
        const field = issue.path.length > 0 ? issue.path.join('.') : '_form';

        if (!(field in errors)) {
            errors[field] = issue.message;
        }
    });

    return { valid: false, errors };
};
